export default __webpack_public_path__ + "static/media/logoScreen.c4987609.png";